module.exports = __webpack_public_path__ + "static/img/0-2 home.45dc6ace.png";